import helpers from "./helpers";

const locale = "es-ES";

const capitalize = (word) =>
  word.charAt(0).toLocaleUpperCase(locale) +
  word.slice(1).toLocaleLowerCase(locale);

const formatNames = (names, transformFn) =>
  names
    .filter(Boolean)
    .flatMap((name) => name.trim().split(/\s+/))
    .map(transformFn)
    .join(" ");

export const formatFullName = (...names) =>
  formatNames(names, capitalize);

export const formatAndMaskFullName = (...names) =>
  formatNames(names, (word) =>
    helpers.maskString(capitalize(word))
  );
